/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Store_App_StoreInputs */

const en_portal_store_app_store = /** @type {(inputs: Portal_Store_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const pl_portal_store_app_store = /** @type {(inputs: Portal_Store_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

/**
* | output |
* | --- |
* | "App Store" |
*
* @param {Portal_Store_App_StoreInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_store_app_store = /** @type {((inputs?: Portal_Store_App_StoreInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Store_App_StoreInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_store_app_store(inputs)
	return en_portal_store_app_store(inputs)
});